module.exports = __webpack_public_path__ + "static/img/permission.ba8db62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/permission.png
// module id = 572
// module chunks = 1